import React, {useEffect, useState} from 'react';
import {circuit} from "../../../../models/circuit";
import {CircuitForm} from "../../../../components/admin/route/CircuitForm";
import {useParams} from "react-router-dom";
import {ApiService} from "../../../../service/ApiService";
import {circuitResultType} from "../../../../types/Api/CircuitResultType";
import {circuitHydrator} from "../../../../models/hydrator/circuitHydrator";
import {Loader} from "../../../../components/admin/Loader";
import {BoxTitle} from "../../../../components/admin/BoxTitle";

export const Edit = () => {
  const uuid: undefined|string = useParams().uuid;

  const [circuit, setCircuit] = useState(undefined as undefined | circuit);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (uuid) {
      const result = ApiService.get(`/circuit/${uuid}`) as Promise<circuitResultType>;

      setLoading(true);

      result
        .then((r) => {
          setCircuit(circuitHydrator.hydrate(r));
        })
        .catch(() => {
          alert("Une erreur c'est produite.")
        })
        .finally(() => {
          setLoading(false);
        });
    }

  }, [uuid]);

  return (
    <>
      {loading && (
        <Loader />
      )}

      {!loading && (circuit || !uuid) && (
        <>
          <BoxTitle title={uuid ? 'Modifier un circuit' : 'Ajouter un circuit'}/>
          <CircuitForm circuit={circuit} />
        </>
      )}
    </>
  );
}
